import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bf78890"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "listItem" }
const _hoisted_2 = { class: "listItemHeader" }
const _hoisted_3 = { class: "vendorName" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex-grow":"1"} }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vendorPurposeOrFeatureLabel" }, "Partner's Privacy Policy", -1))
const _hoisted_6 = { class: "vendorPurposeOrFeatureDesc" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vendorPurposeOrFeatureID" }, " ", -1))
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggle_button = _resolveComponent("toggle-button")!
  const _component_ChevronIcon = _resolveComponent("ChevronIcon")!
  const _component_Vue3SlideUpDown = _resolveComponent("Vue3SlideUpDown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.vendor.name), 1),
      _hoisted_4,
      _createVNode(_component_toggle_button, {
        onChange: _ctx.changeConsent,
        sync: true,
        value: _ctx.consent,
        style: {"margin-left":"8px"},
        width: 64,
        height: 30,
        speed: 200,
        color: {checked: '#34b76f', unchecked: '#94a7d1'}
      }, null, 8, ["onChange", "value"]),
      _createVNode(_component_ChevronIcon, {
        onClick: _ctx.expandCollapseClick,
        class: _normalizeClass(_ctx.collapseClass)
      }, null, 8, ["onClick", "class"])
    ]),
    _createVNode(_component_Vue3SlideUpDown, {
      modelValue: _ctx.expanded,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.expanded) = $event)),
      duration: 200,
      class: "listItemDetail"
    }, {
      default: _withCtx(() => [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("a", {
            style: {"font-weight":"600"},
            target: "_blank",
            href: this.vendor.policyUrl
          }, _toDisplayString(this.vendor.policyUrl), 9, _hoisted_8)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}